import { Box, Container, CssBaseline, Stack, Toolbar } from '@mui/material';
import ProjectsHeader from '../Components/Projects/ProjectsHeader';
import RapidRobotsCarousel from '../Components/RapidRobots/RapidRobotsCarousel';

const RapidRobotsPage = () => {
  return (
    <>
      <CssBaseline />
      <Container
        sx={{
          height: 'calc(100vh - 50px)',
          padding: '24px',
          boxSizing: 'border-box',
          margin: '0',
          flexGrow: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
        maxWidth={false}
      >
        <Box sx={{ flex: 1, minHeight: 0 }}>
          <Stack spacing={1} sx={{ height: '100%', minHeight: 0 }}>
            <Toolbar />
            <ProjectsHeader />
            <Box sx={{ flex: 1, minHeight: 0, py: 2 }}>
              <RapidRobotsCarousel />
            </Box>
          </Stack>
        </Box>
      </Container>
    </>
  );
};

export default RapidRobotsPage;
